import Cookies from "js-cookie";

import { TIMEOUT_REDIRECT } from "@/shared/constants/timeout.constant";

// eslint-disable-next-line
export default async function(context) {
  if (Cookies.get("r")) {
    try {
      await context.store.dispatch("auth/authRefresh", {
        data: {
          refresh: Cookies.get("r"),
        },
      });
    } catch (error) {
      context.store.dispatch("auth/authDestroy");
      const timeoutId = setTimeout(() => {
        clearTimeout(timeoutId);
        context.store.dispatch("app/toggleSnackBar", {
          message: "Your session is expired.",
          color: "invert-error",
          isNoSidebarToolbar: true,
        });
      }, TIMEOUT_REDIRECT);
    }
  } else {
    // context.redirect('/');
    context.store.dispatch("auth/authDestroy");
  }

  // context.$axios.setToken(context.store.getters['auth/getUserToken'], 'Bearer');

  context.$axios.onRequest(() => {
    const cookieToken = Cookies.get("t");
    context.$axios.setToken(cookieToken, "Bearer");
  });

  // context.$axios.onResponse(res => res.data);

  context.$axios.onResponseError((res) => {
    throw res.response === undefined
      ? { message: res.message }
      : res.response.data;
    // context.store.dispatch('app/toggleSnackBar', response.message);
  });
}
